var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-menu'),_c('div',{staticClass:"view"},[_c('router-view')],1),_c('footer-menu'),(_vm.$route.name != 'Home')?_c('div',[_c('back-to-top-button')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }